module.exports = __webpack_public_path__ + "static/media/whatsappBusiness.551e40bf.png";